import { FieldType, FileUploadingStatus } from "@/enums";

export const getUpdatedFieldValue = (fileList, fieldType) => {
  const value = fileList?.map(
    ({ blobUrl, name, type, blobListIds, status }) => {
      const res = {
        url: blobUrl,
        name,
        contentType: type,
        blobListIds,
      };
      if (status !== FileUploadingStatus.done) res.status = status;
      return res;
    }
  );

  if (fieldType === FieldType.MultiAttachment) {
    return value;
  }

  if (value.length) {
    return value[value.length - 1];
  }
};
